/**
 * <strong>Purpose:</strong> <br>
 * Provides specific size calculations for drop down-like buttons.<br>
 *
 * <strong>Contract:</strong> <br>
 * This mixin is dependent upon: <br>
 * {@link module:mw-form/mixins/property/SizeMixin}<br>
 *
 * @module MW/toolstrip/form/mixins/property/DropDownButtonSizeMixin
 *
 * @copyright Copyright 2016 The MathWorks, Inc.
 */

define([
        "dojo/_base/declare",
        "MW/toolstrip/mixins/property/SizeMixin"
    ],
    function (declare, SizeMixin) {

        var DropDownButtonSizeMixin =  declare(null, {

            /**
             * Duplicate method from "SizeMixin", overriding non-toolstrip DropDownButtonSizeMixin code
             * @private
             */
            _setSize: function () {
                // User cannot set size on toolstrip
            }
        });

        DropDownButtonSizeMixin._dependencies = [
            {mixin: SizeMixin, orderDependent: true}
        ];

        return DropDownButtonSizeMixin;

    });
